import { useState } from "react"
import { preventClick } from "../../include/function"
import Spinner from "./Spinner"

const YesOrNo = ({ zIndex, handleYes, handleNo, headerText, yesBtnText, loading }) => {
    const [popDown, setPopDown] = useState(false)

    const yes = () => handleYes()

    const no = () => {
        setPopDown(true)
        setTimeout(() => {
            handleNo()
        }, 100);
    }

    return <div
  className="position-fixed start-0 top-0 vh-100 w-100 d-flex align-items-center justify-content-center p-3"
  style={{ zIndex: zIndex, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
>
  <div
    className={`bg-white p-4 rounded-4 border border-light shadow-lg text-center ${popDown ? 'pop-down' : 'pop-up'}`}
    style={{ maxWidth: "400px", width: "100%" }}
  >
    <h5 className="fw-semibold mb-4 text-dark">{headerText}</h5>

    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
      {loading ? (
        <button
          className="btn btn-danger btn-lg px-4 d-flex align-items-center justify-content-center"
          onClick={e => e.preventDefault()}
        >
          <Spinner spinnerSize="sm" color="light" />
          <span className="ms-2">{yesBtnText}</span>
        </button>
      ) : (
        <button
          className="btn btn-danger btn-lg px-4"
          onClick={e => preventClick(e, yes)}
        >
          {yesBtnText}
        </button>
      )}

      <button
        className="btn btn-secondary btn-lg px-4"
        onClick={e => preventClick(e, no)}
      >
        Cancel
      </button>
    </div>
  </div>
</div>

}

export default YesOrNo